export const beforeUnload = (event) => {
  event.returnValue = 'Are you sure you want to leave?'
}
